import styled from 'styled-components';
import { Modal as AntModal } from 'antd';

import { buttonStyle } from 'ui/components/Buttons';

import { BORDER_RADIUS } from '../constants';

import { IModalConfirmProps } from '../types';

export const StyledConfirmModal = styled(AntModal)<IModalConfirmProps>`
  & .ant-modal-content {
    border-radius: ${BORDER_RADIUS};
    box-shadow:
      0px 8px 22px -6px #18274b0f,
      0px 14px 64px -4px #18274b0f;
    padding: 0 !important;
  }

  & .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${props =>
      props.modalType?.startsWith('whale') ? '16px 32px 24px' : '16px 32px 32px'};

    & .text-container {
      margin-top: 16px;
      white-space: pre-line;
      text-align: center;
      width: 100%;

      & .title {
        font-size: 20px;
        line-height: 28px;
        font-weight: 700;
        margin-bottom: 16px;
      }

      & .subTitle {
        font-weight: 500;
        margin-bottom: 16px;
      }

      & .content {
        margin-bottom: 16px;
      }

      & .text {
        max-height: ${props => (props.size === 'small' ? '96px' : '48px')};
        overflow-y: auto;
        & span {
          line-height: 24px;
        }
      }
    }

    & .bgEllipse {
      border-radius: ${BORDER_RADIUS};
      overflow: hidden;
      position: absolute;
      left: 0;
      top: 0;
    }

    & .modalIcon {
      position: relative;
      margin-top: ${props =>
        props.modalType?.startsWith('whale') ? '0px' : props.size === 'small' ? '32px' : '52px'};
      height: ${props => (props.modalType?.startsWith('whale') ? '176px' : 'auto')};
    }
  }

  & .ant-modal-footer {
    border-top: unset;
    display: flex;
    justify-content: center;
    padding: 0 16px 32px 16px;
  }

  ${buttonStyle}
`;
